// SYNC NOTE: these colors must also be updated in /public/logo.svg (the favicon).
const C = {
  berry:     "#3c6e71",
  sheen:     "#7bb6b9",
  calyx:     "#284b63",
  highlight: "#3e7397",
} as const;

type Props = {
  size?: number;
  title?: string;
};

export function Logo({ size = 28, title = "Hushberry" }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      width={size}
      height={size}
      role="img"
      aria-label={title}
      style={{ display: "inline-block", flexShrink: 0 }}
    >
      <path
        d="M32 58 C32 58 6 40 6 24 C6 14 17 10 25 17 C28 19 30 22 32 25 C34 22 36 19 39 17 C47 10 58 14 58 24 C58 40 32 58 32 58 Z"
        fill={C.berry}
      />
      <path
        d="M16 18 C12 22 11 30 14 36 C16 31 19 27 23 23 C20 20 18 18 16 18 Z"
        fill={C.sheen}
        opacity="0.7"
      />
      <g fill="#ffffff" opacity="0.9">
        <ellipse cx="22" cy="32" rx="1.3" ry="2.2" transform="rotate(-25 22 32)" />
        <ellipse cx="32" cy="36" rx="1.3" ry="2.2" />
        <ellipse cx="42" cy="32" rx="1.3" ry="2.2" transform="rotate(25 42 32)" />
        <ellipse cx="26" cy="44" rx="1.3" ry="2.2" transform="rotate(-15 26 44)" />
        <ellipse cx="38" cy="44" rx="1.3" ry="2.2" transform="rotate(15 38 44)" />
      </g>
      <path d="M20 16 L23 8 L28 18 L32 6 L36 18 L41 8 L44 16 L32 26 Z" fill={C.calyx} />
      <path d="M32 26 L30 14 L32 16 L34 14 Z" fill={C.highlight} />
    </svg>
  );
}
